/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class ConflictError extends errors.TruvityError {
    constructor(body: Truvity.ConflictProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'ConflictError',
            statusCode: 409,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, ConflictError.prototype);
    }
}
